import React from 'react'
import { Link } from 'react-router-dom'
import ReadMore from '../Common/ReadMore'
import Slider from "react-slick";
import { getImages } from '../const';

const SrpSmBox = ({ item, index, numberFormatter, priceFormatter }) => {

    const optionssl = {
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: true
    };

    const tagLabels = [];

    if (item.certified_pre_owned) tagLabels.push("Certified");
    else if (item.inventory_manage.incoming) tagLabels.push("Incoming");
    else if (item.inventory_manage.new_arrival) tagLabels.push("New Arrival");
    
    if (item.vehicle_type == "recently sold") tagLabels.push("Recently Sold");
    return (
        <>
            <div className='col-lg-4 col-md-6 col-12' key={index}>
                {/*console.log("tagLabels", tagLabels)*/}
                <div className='pro-box'>
                    <div className='pro-content'>
                        <div className='before-hover'>
                            {tagLabels?.length > 0 &&
                                <div className='srp-tags'>
                                    {tagLabels.map((tagLabel, i) =>
                                        (<span key={i} className={`srp-tag ms-1 ${tagLabel.toLowerCase().replace(/\s+/g, '-')}`}>
                                            {tagLabel.toLowerCase() === "certified" && <img className='me-2' src={getImages('check-circle-icon.png')}/>}
                                            {tagLabel}
                                        </span>)
                                    )}
                                </div>
                            }
                            <div className='pro-top'>
                                <img src={item.images[0]} alt='srp' />
                            </div>
                            <div className='pro-bottom'>
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                    <div className="fv-title mb-0">{item.vehicle_name}</div>
                                    <div>
                                        <button className='info-icon'>
                                            <img src={getImages('info-icon.png')} alt='icon' />
                                        </button>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between mt-1">
                                    <div className="fv-price">{item.price > 0 ? priceFormatter(item.price, true) : <a href='tel:4079880111' className='xs-title text-white'>CALL FOR PRICE</a>}</div>
                                    <div className="fv-mileage">{numberFormatter(item.mileage)} miles</div>
                                </div>
                                <div className='mt-2'>
                                    <Link
                                        to={"/vehicle-details/" + item.vdp_url}
                                        type='button'
                                        className='vehicle-dtl-btn xs-title text-uppercase text-center'>
                                        Vehicle Details
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className='after-hover'>
                            {tagLabels?.length > 0 &&
                                <div className='srp-tags'>
                                    {tagLabels.map((tagLabel, i) =>
                                        (<span key={i} className={`srp-tag ms-1 ${tagLabel.toLowerCase().replace(/\s+/g, '-')}`}>{tagLabel}</span>)
                                    )}
                                </div>
                            }
                            <div className='pro-top'>
                            {2 in item.images ? <Slider
                                    className="featured-slider"
                                    {...optionssl}
                                >
                                    <div className="slide-item">
                                        <Link to={"/vehicle-details/" + item.vdp_url}>
                                            <img src={item.images[0]} />
                                        </Link>
                                    </div>
                                    <div className="slide-item">
                                        <Link to={"/vehicle-details/" + item.vdp_url}>
                                            <img src={item.images[1]} />
                                        </Link>
                                    </div>
                                    <div className="slide-item">
                                        <Link to={"/vehicle-details/" + item.vdp_url}>
                                            <img src={item.images[2]} />
                                        </Link>
                                    </div>
                                </Slider> : <img src={item.images[0]} />}
                            </div>
                            <div className='pro-bottom'>
                                <div className="d-flex align-items-center justify-content-between prob-info flex-wrap">
                                    <div className='w-50 pe-4'>
                                        <div className='d-flex align-items-center w-100 mb-xl-2'>
                                            <div className='xs-title fw-400 w-30'>Stock #</div>
                                            <div className='sm-title text-end w-70'>{item.stockno}</div>
                                        </div>
                                        <div className='d-flex align-items-center w-100'>
                                            <div className='xs-title fw-400 w-30'>VIN</div>
                                            <div className='sm-title text-end w-70'>{item.vin}</div>
                                        </div>
                                    </div>
                                    <div className='w-50 ps-3'>
                                        {item.interior_color &&
                                            <div className='d-flex align-items-center w-100 mb-xl-2'>
                                                <div className='xs-title fw-400 w-40'>Interior Color</div>
                                                <div className='sm-title text-end w-60'>{item.interior_color}</div>
                                            </div>
                                        }
                                        {item.exterior_color &&
                                            <div className='d-flex align-items-center w-100'>
                                                <div className='xs-title fw-400 w-40'>Exterior Color</div>
                                                <div className='sm-title text-end w-60'>{item.exterior_color}</div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <hr className='custom-hr' />
                                <ReadMore
                                    key={index}
                                    text={item.description}
                                    maxChars={230}
                                    sectionId="aboutVdp"
                                    readMoreUrl={"/vehicle-details/" + item.vdp_url}
                                />
                                <div className="d-flex align-items-center justify-content-between mt-2 pt-2 srp-actions-flex">
                                    {/* <div>
                                        <button type='button' className='view-sticker-btn text-green'><span className='doc_icon'></span> View Window Sticker</button>
                                    </div> */}
                                    <div className='w-100 text-center'>
                                        <Link to={"/vehicle-details/" + item.vdp_url} className="orange-btn text-uppercase" >Vehicle Details</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SrpSmBox